<template>
	<div>
		<CModal :title="title" size="lg" :show.sync="showModal">
			<template v-if="!loading">
				<GDataTable
					ref="mainTable"
					:items="items"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					pagination
					column-filter
				>
					<template #id="{ item }">
						<td>
							<template v-if="item.id">
								<router-link :to="`/orders/${item.parentOrder.id}/edit`" target="_blank">
									{{ item.id }}
								</router-link>
							</template>
							<template v-else>
								<CIcon name="cil-ban" />
							</template>
						</td>
					</template>

					<template #state="{ item }">
						<td>
							<template v-if="item.state">
								<CBadge :color="statusColor[item.state]">{{
									statusTranslation[item.state]
								}}</CBadge>
							</template>
							<template v-else>
								<CIcon name="cil-ban" />
							</template>
						</td>
					</template>

					<template #slip.salePts.name="{ item }">
						<td>
							<template
								v-if="
									item.slip &&
									item.slip.salePts &&
									(item.slip.salePts.reference || item.slip.salePts.name)
								"
							>
								[{{ item.slip.salePts.reference }}] {{ item.slip.salePts.name }}
							</template>
							<template v-else>
								<CIcon name="cil-ban" />
							</template>
						</td>
					</template>

					<template #slip.depotPts.name="{ item }">
						<td>
							<template
								v-if="
									item.slip &&
									item.slip.depotPts &&
									(item.slip.depotPts.reference || item.slip.depotPts.name)
								"
							>
								[{{ item.slip.depotPts.reference }}] {{ item.slip.depotPts.name }}
							</template>
							<template v-else>
								<CIcon name="cil-ban" />
							</template>
						</td>
					</template>

					<template #parentOrder.concept="{ item }">
						<td>
							<template v-if="item.parentOrder && item.parentOrder.concept">
								<CBadge :color="orderConceptColor[item.parentOrder.concept]">{{
									orderConceptTranslation[item.parentOrder.concept]
								}}</CBadge>
							</template>
							<template v-else>
								<CIcon name="cil-ban" />
							</template>
						</td>
					</template>

					<template #weightGross="{ item }">
						<td>{{ $numeral(item.weightGross).format('0,0.00') }} KG</td>
					</template>

					<template #weightNet="{ item }">
						<td>{{ $numeral(item.weightNet).format('0,0.00') }} KG</td>
					</template>

					<template #uv="{ item }">
						<td>
							{{ $numeral(item.uv).format('0,0.00') }}
						</td>
					</template>
				</GDataTable>

				<table class="table table-bordered">
					<thead>
						<tr>
							<th>Produit</th>
							<th>Quantité</th>
							<th>Etq Imprimées</th>
							<th>Etq Non-Imprimées</th>
							<th>Poids brut</th>
							<th>Poids net</th>
							<th>Volume</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>TOTAL</td>
							<td>{{ summary.quantity }}</td>
							<td>{{ summary.quantityLabelGenerated }}</td>
							<td>{{ summary.quantityLabelNotGenerated }}</td>
							<td>{{ $numeral(summary.weightGross).format('0,0.00') }} KG</td>
							<td>{{ $numeral(summary.weightNet).format('0,0.00') }} KG</td>
							<td>{{ $numeral(summary.volume).format('0,0.00') }}</td>
						</tr>
					</tbody>
				</table>
			</template>
			<p v-else>Chargement...</p>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GDataTable from '../../components/ghostlexly-components/GDataTable';

	export default {
		props: {
			title: {
				type: String,
				default: 'Consultez le détail des colis',
			},
		},

		components: {
			GDataTable,
		},

		watch: {
			showModal(val) {
				this.$emit('updateModal', val);
			},
		},

		data() {
			this.statusOptions = [
				{ value: 'order_item.pending', label: 'Etiquette non-imprimée' },
				{ value: 'order_item.label_printed', label: 'Etiquette imprimée' },
				{ value: 'order_item.orphan', label: 'Dé-scannée' },
			];

			this.orderConceptOptions = [
				{ value: 'order.colipays', label: 'Colipays' },
				{ value: 'order.colikado', label: 'Colikado' },
				{ value: 'order.aupaysdesfleurs', label: 'Au pays des fleurs' },
			];

			return {
				loading: false,
				items: [],
				summary: {},
				fields: [
					{ key: 'id', label: 'ID' },
					{ key: 'name', label: 'Nom colis' },
					{
						key: 'state',
						label: 'Statut',
						type: 'select',
						filterSelectOptions: this.statusOptions,
						sorter: false,
					},
					{ key: 'slip.identifier', label: 'N° Bordereau' },
					{ key: 'shippingNumber', label: 'Numéro de suivi (transport)' },
					{ key: 'slip.salePts.name', label: 'Point de vente' },
					{ key: 'slip.depotPts.name', label: 'Point de dépôt' },
					{
						key: 'parentOrder.concept',
						label: 'Concept',
						type: 'select',
						filterSelectOptions: this.orderConceptOptions,
						sorter: false,
					},
					{
						key: 'weightGross',
						label: 'Poids brut',
					},
					{
						key: 'weightNet',
						label: 'Poids net',
					},
					{
						key: 'uv',
						label: 'Volume',
					},
				],
				orderConceptTranslation: {
					'order.colipays': 'Colipays',
					'order.colikado': 'Colikado',
					'order.aupaysdesfleurs': 'Au pays des fleurs',
				},
				orderConceptColor: {
					'order.colipays': 'warning',
					'order.colikado': 'danger',
					'order.aupaysdesfleurs': 'success',
				},
				statusTranslation: {
					'order_item.pending': 'Étiquette non imprimée',
					'order_item.label_printed': 'Étiquette imprimée',
					'order_item.orphan': 'Colis retirés',
					'order_item.scanned': 'Colis scanné',
					'order_item.paused': 'Colis en pause',
					'order_item.refunded': 'Colis remboursé',
				},
				statusColor: {
					'order_item.pending': 'danger',
					'order_item.label_printed': 'warning',
					'order_item.orphan': 'warning',
					'order_item.scanned': 'success',
					'order_item.paused': 'danger',
					'order_item.refunded': 'warning',
				},
				showModal: false,
			};
		},
		methods: {
			async loadData(date) {
				if (!date) {
					this.$toast.error('Veuillez sélectionner une date');
					return;
				}

				this.loading = true;
				let baseQuery = '/api/order_items?';
				let params = new URLSearchParams();

				params.append('shippingDate[after]', date + 'T00:00:00.000Z');
				params.append('shippingDate[before]', date + 'T23:59:59.999Z');
				params.append('state[]', 'order_item.pending');
				params.append('state[]', 'order_item.orphan');
				params.append('state[]', 'order_item.label_printed');
				params.append('itemsPerPage', 50000);

				try {
					const res = await this.$axios.get(baseQuery + params.toString());
					if (res.status === 200) {
						if (res.data['hydra:totalItems'] > 0) {
							this.items = res.data['hydra:member'].filter(
								item =>
									!(
										item.parentOrder.concept === 'order.colikado' &&
										(!item.slip.depotPts || Object.keys(item.slip.depotPts).length === 0)
									)
							);

							this.summary = this.items.reduce(
								(acc, item) => {
									acc.quantityLabelGenerated +=
										item.state === 'order_item.label_printed' ||
										item.state === 'order_item.orphan'
											? 1
											: 0;
									acc.quantityLabelNotGenerated +=
										item.state !== 'order_item.label_printed' &&
										item.state !== 'order_item.orphan'
											? 1
											: 0;
									acc.weightGross += item.weightGross;
									acc.weightNet += item.weightNet;
									acc.volume += item.uv;

									return acc;
								},
								{
									quantity: this.items.length ?? 0,
									quantityLabelGenerated: 0,
									quantityLabelNotGenerated: 0,
									weightGross: 0,
									weightNet: 0,
									volume: 0,
								}
							);
						}
					} else throw new Error();
				} catch (err) {
					this.$toast.error('Une erreur est survenue lors de la récupération des colis en attente');
				}
				this.loading = false;
			},
		},
	};
</script>
